import React, { useState, useEffect } from "react";
import "./index.less";
import { Link, useLocation } from "react-router-dom";
import { VerticalAlignTopOutlined,PhoneOutlined,QrcodeOutlined,CustomerServiceOutlined } from "@ant-design/icons";

const FixedLink = () => {
  const location = useLocation();
  const pathname = location?.pathname || '';
  const [isVisible, setIsVisible] = useState(true);
  
  // 检查是否是首页
  const isHomePage = pathname === '/';
  
  useEffect(() => {
    if (!isHomePage) {
      // 如果不是首页，始终显示
      setIsVisible(true);
      return;
    }
    
    // 如果是首页，根据滚动位置决定是否显示
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      // 如果滚动位置小于视口高度（banner区域），隐藏 FixedLink
      setIsVisible(scrollTop >= windowHeight);
    };
    
    // 初始检查
    handleScroll();
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isHomePage]);
  
  // 如果不显示，返回 null
  if (!isVisible) {
    return null;
  }
  
  return (
    <div className="FixedLink">
      {/* 合作咨询 */}
      {/* in-show和hover-show是两个状态，in-show是默认状态，hover-show是鼠标悬停状态 */}
      <Link 
        className="link-us jump" 
        to="/about#email-content" 
        state={{ type: 2 }}
      >
        <div className="in-show">
          <CustomerServiceOutlined />
          <p>合作咨询</p>
        </div>
        <div className="hover-show">
          <h3>一对一专业企业顾问</h3>
          <p>工作日 9:00-18:00</p>
        </div>
      </Link>


       {/* 联系信息 */}
      <div className="message-us">
        <div className="phone cube">
          <div className="in-show">
            <PhoneOutlined />
            <p>电话</p>
          </div>
          <div className="hover-show">
            <h3>400-855-2725</h3>
            <p>工作日 9:00-18:00</p>
          </div>
        </div>
        <div className="code cube">
          <div className="in-show">
            <QrcodeOutlined />
            <p>二维码</p>
          </div>
          <div className="hover-show">
            <img src={require("@/assets/scancode-1.jpg")} alt="" />
          </div>
        </div>
      </div>


      {/* 返回顶部 */}
      <div className="go-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <VerticalAlignTopOutlined />
      </div>
    </div>
  );
};

export default FixedLink;
